module.exports = __webpack_public_path__ + "static/On-shore-model-d1f23e49faef3478aa952a2d7d509962.png";